export default "__VITE_ASSET__08465050__"